import { Pie } from "react-chartjs-2";

import Chart from "chart.js";

const GenderChart = ({ genderCount }) => {
	const data = {
		labels: ["여성", "남성", "알수없음"],
		datasets: [
			{
				data: [genderCount?.female, genderCount?.male, genderCount?.unknown],
				backgroundColor: [
					"rgba(255, 99, 132, 0.2)",
					"rgba(54, 162, 235, 0.2)",
					// 'rgba(255, 206, 86, 0.2)',
					// 'rgba(75, 192, 192, 0.2)',
					// 'rgba(153, 102, 255, 0.2)',
					"rgba(255, 159, 64, 0.2)",
				],
				borderColor: [
					"rgba(255, 99, 132, 1)",
					"rgba(54, 162, 235, 1)",
					// 'rgba(255, 206, 86, 1)',
					// 'rgba(75, 192, 192, 1)',
					// 'rgba(153, 102, 255, 1)',
					"rgba(255, 159, 64, 1)",
				],
				borderWidth: 1,
			},
		],
	};

	const options = {
		responsive: true,
		plugins: {
			legend: {
				position: "top",
			},
			title: {
				display: true,
				text: "성별",
			},
		},
	};

	return (
		<div
			style={{
				position: "relative",
				width: "100%",
			}}
		>
			<Pie data={data} options={options} />
		</div>
	);
};

export default GenderChart;
